import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ab253e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x1 sm:gap-x4" }
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = { value: "" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

import InputText from '@/shared/form/InputText.vue';
import { manuallyTypedCityOptionValue, usePostalCodeSuggest } from '@/shared/address/usePostalCodeSuggest';
import { useField, Field } from 'vee-validate';
import { computed, watch } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'PostalCodeSuggest',
  props: {
    postalCodeName: { default: 'postalCode' },
    postalCodeLabel: { default: undefined },
    cityName: { default: 'city' },
    cityLabel: { default: undefined },
    selectCityLabel: { default: undefined },
    selectAnotherCityLabel: { default: undefined },
    isUnknownPostalCodeName: { default: 'isUnknownPostalCode' },
    postalCodeRules: { default: undefined },
    cityRules: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { postalCodeName: string, postalCodeLabel: string, cityName: string, cityLabel: string, selectCityLabel:string, selectAnotherCityLabel:string, isUnknownPostalCodeName: string, postalCodeRules: string, cityRules: string }



const blockLabels = useBlockLabels();
const labels = computed(() => {
    return {
        postalCode: props.postalCodeLabel ?? blockLabels.baseAddressPostalCode,
        city: props.cityLabel ?? blockLabels.baseAddressCity,
        selectCity: props.selectCityLabel ?? blockLabels.baseAddressSelectCity,
        selectAnotherCity: props.selectAnotherCityLabel ?? blockLabels.baseAddressAnotherCity,
    };
});

const { postalCodeFieldModel, cityModel, selectedMultiCityOption, hasMultipleCities, cities, manuallyTypedCity, isUnknownPostalCode } = usePostalCodeSuggest();

const { value: postalCodeFieldValue } = useField<string | undefined>(props.postalCodeName);
const { value: cityFieldValue } = useField<string | undefined>(props.cityName);

const unwatchFirstTimeVeeValidatePostalCodeFieldValueUpdate = watch(postalCodeFieldValue, (value) => {
    if (value) {
        postalCodeFieldModel.value = value;
        unwatchFirstTimeVeeValidatePostalCodeFieldValueUpdate && unwatchFirstTimeVeeValidatePostalCodeFieldValueUpdate();
    }
}, { immediate: true });

const unwatchFirstTimeVeeValidateCityFieldValueUpdate = watch(cityFieldValue, (value) => {
    if (value) {
        cityModel.value = value;
        unwatchFirstTimeVeeValidateCityFieldValueUpdate && unwatchFirstTimeVeeValidateCityFieldValueUpdate();
    }
}, { immediate: true });

const onMultiCitySelect = (): void => {
    const value = selectedMultiCityOption.value;
    if (value !== manuallyTypedCityOptionValue) {
        cityModel.value = value;
    } else {
        cityModel.value = '';
    }
};


return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Field), {
      modelValue: _unref(isUnknownPostalCode),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isUnknownPostalCode) ? (isUnknownPostalCode).value = $event : null)),
      name: __props.isUnknownPostalCodeName,
      class: "hide-from-view-but-include-in-form-data",
      "aria-hidden": "true",
      readonly: "readonly",
      tabindex: "-1",
      disabled: ""
    }, null, 8, ["modelValue", "name"]),
    _createVNode(InputText, {
      modelValue: _unref(postalCodeFieldModel),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(postalCodeFieldModel) ? (postalCodeFieldModel).value = $event : null)),
      name: __props.postalCodeName,
      label: _unref(labels).postalCode
    }, null, 8, ["modelValue", "name", "label"]),
    (_unref(hasMultipleCities))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_InputSelect, {
            modelValue: _unref(selectedMultiCityOption),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedMultiCityOption) ? (selectedMultiCityOption).value = $event : null)),
            class: "w-full -mt-2",
            "show-errors": false,
            label: _unref(labels).city,
            name: "multi-city-select",
            onChange: onMultiCitySelect
          }, {
            default: _withCtx(() => [
              _createElementVNode("option", _hoisted_3, _toDisplayString(_unref(labels).selectCity), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cities), (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city,
                  value: city
                }, _toDisplayString(city), 9, _hoisted_4))
              }), 128)),
              _createElementVNode("option", { value: _unref(manuallyTypedCityOptionValue) }, _toDisplayString(_unref(labels).selectAnotherCity), 9, _hoisted_5)
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          (!_unref(manuallyTypedCity))
            ? (_openBlock(), _createBlock(_component_InputErrorMessage, {
                key: 0,
                class: "absolute mt-5 text-12",
                name: __props.cityName
              }, null, 8, ["name"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      appear: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(InputText, {
          modelValue: _unref(cityModel),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(cityModel) ? (cityModel).value = $event : null)),
          name: __props.cityName,
          label: _unref(labels).city
        }, null, 8, ["modelValue", "name", "label"]), [
          [_vShow, _unref(manuallyTypedCity) || !_unref(hasMultipleCities)]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})